import request from '@/utils/request'

export async function wxNativePay (data) {
    return request({
      url: '/mybio-server/c/service/H5/wxNativePay',
      method: 'post',
      data
    })
  }


// WEBPACK FOOTER //
// ./src/api/index.js